const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';
const DOCKER_BUILD_BASE_URL = ``;

export const API_ENDPOINTS = {
    PEOPLE_BUBBLE: (dbName) => `${DOCKER_BUILD_BASE_URL}/api/peoplebubblechart/${dbName}`,
    GRAPH_DATA: (dbName) => `${DOCKER_BUILD_BASE_URL}/api/graphData/${dbName}`,
    ENTITY_TRIPLE: `${DOCKER_BUILD_BASE_URL}/graph/entitytripledata`,
};